/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfGetSmsTemplateGroupByIdDto } from '../models/custom-result-of-get-sms-template-group-by-id-dto';
import { CustomResultOfListOfGetSmsTemplateGroupListDto } from '../models/custom-result-of-list-of-get-sms-template-group-list-dto';
import { CustomResultOfListOfGetSmsTemplateGroupsDto } from '../models/custom-result-of-list-of-get-sms-template-groups-dto';
import { CustomResultOfPaginatedListOfGetSmsTemplateGroupsDto } from '../models/custom-result-of-paginated-list-of-get-sms-template-groups-dto';
import { smsTemplateGroupsCreateGet } from '../fn/sms-template-groups/sms-template-groups-create-get';
import { SmsTemplateGroupsCreateGet$Params } from '../fn/sms-template-groups/sms-template-groups-create-get';
import { smsTemplateGroupsCreatePost } from '../fn/sms-template-groups/sms-template-groups-create-post';
import { SmsTemplateGroupsCreatePost$Params } from '../fn/sms-template-groups/sms-template-groups-create-post';
import { smsTemplateGroupsDelete } from '../fn/sms-template-groups/sms-template-groups-delete';
import { SmsTemplateGroupsDelete$Params } from '../fn/sms-template-groups/sms-template-groups-delete';
import { smsTemplateGroupsGetSmsTemplateGroupByParentId } from '../fn/sms-template-groups/sms-template-groups-get-sms-template-group-by-parent-id';
import { SmsTemplateGroupsGetSmsTemplateGroupByParentId$Params } from '../fn/sms-template-groups/sms-template-groups-get-sms-template-group-by-parent-id';
import { smsTemplateGroupsGetSmsTemplateGroupList } from '../fn/sms-template-groups/sms-template-groups-get-sms-template-group-list';
import { SmsTemplateGroupsGetSmsTemplateGroupList$Params } from '../fn/sms-template-groups/sms-template-groups-get-sms-template-group-list';
import { smsTemplateGroupsGetSmsTemplateGroupsAudit } from '../fn/sms-template-groups/sms-template-groups-get-sms-template-groups-audit';
import { SmsTemplateGroupsGetSmsTemplateGroupsAudit$Params } from '../fn/sms-template-groups/sms-template-groups-get-sms-template-groups-audit';
import { smsTemplateGroupsGetSmsTemplateGroupsWithPagination } from '../fn/sms-template-groups/sms-template-groups-get-sms-template-groups-with-pagination';
import { SmsTemplateGroupsGetSmsTemplateGroupsWithPagination$Params } from '../fn/sms-template-groups/sms-template-groups-get-sms-template-groups-with-pagination';
import { smsTemplateGroupsUpdateGet } from '../fn/sms-template-groups/sms-template-groups-update-get';
import { SmsTemplateGroupsUpdateGet$Params } from '../fn/sms-template-groups/sms-template-groups-update-get';
import { smsTemplateGroupsUpdatePut } from '../fn/sms-template-groups/sms-template-groups-update-put';
import { SmsTemplateGroupsUpdatePut$Params } from '../fn/sms-template-groups/sms-template-groups-update-put';

@Injectable({ providedIn: 'root' })
export class SmsTemplateGroupsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `smsTemplateGroupsCreateGet()` */
  static readonly SmsTemplateGroupsCreateGetPath = '/SmsTemplateGroups/Create';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smsTemplateGroupsCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  smsTemplateGroupsCreateGet$Response(params?: SmsTemplateGroupsCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return smsTemplateGroupsCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smsTemplateGroupsCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smsTemplateGroupsCreateGet(params?: SmsTemplateGroupsCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.smsTemplateGroupsCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `smsTemplateGroupsCreatePost()` */
  static readonly SmsTemplateGroupsCreatePostPath = '/SmsTemplateGroups/Create';

  /**
   * Create SmsTemplate Group.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smsTemplateGroupsCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smsTemplateGroupsCreatePost$Response(params: SmsTemplateGroupsCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return smsTemplateGroupsCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create SmsTemplate Group.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smsTemplateGroupsCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smsTemplateGroupsCreatePost(params: SmsTemplateGroupsCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.smsTemplateGroupsCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `smsTemplateGroupsGetSmsTemplateGroupsWithPagination()` */
  static readonly SmsTemplateGroupsGetSmsTemplateGroupsWithPaginationPath = '/SmsTemplateGroups/GetSmsTemplateGroupsWithPagination';

  /**
   * For each user get TemplateGroups with paging.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smsTemplateGroupsGetSmsTemplateGroupsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smsTemplateGroupsGetSmsTemplateGroupsWithPagination$Response(params: SmsTemplateGroupsGetSmsTemplateGroupsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetSmsTemplateGroupsDto>> {
    return smsTemplateGroupsGetSmsTemplateGroupsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * For each user get TemplateGroups with paging.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smsTemplateGroupsGetSmsTemplateGroupsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smsTemplateGroupsGetSmsTemplateGroupsWithPagination(params: SmsTemplateGroupsGetSmsTemplateGroupsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetSmsTemplateGroupsDto> {
    return this.smsTemplateGroupsGetSmsTemplateGroupsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetSmsTemplateGroupsDto>): CustomResultOfPaginatedListOfGetSmsTemplateGroupsDto => r.body)
    );
  }

  /** Path part for operation `smsTemplateGroupsGetSmsTemplateGroupByParentId()` */
  static readonly SmsTemplateGroupsGetSmsTemplateGroupByParentIdPath = '/SmsTemplateGroups/GetSmsTemplateGroupByParentId';

  /**
   * دریافت لیست گروه الگو پیامک بر اسا شناسه والد.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smsTemplateGroupsGetSmsTemplateGroupByParentId()` instead.
   *
   * This method doesn't expect any request body.
   */
  smsTemplateGroupsGetSmsTemplateGroupByParentId$Response(params?: SmsTemplateGroupsGetSmsTemplateGroupByParentId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetSmsTemplateGroupsDto>> {
    return smsTemplateGroupsGetSmsTemplateGroupByParentId(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست گروه الگو پیامک بر اسا شناسه والد.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smsTemplateGroupsGetSmsTemplateGroupByParentId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smsTemplateGroupsGetSmsTemplateGroupByParentId(params?: SmsTemplateGroupsGetSmsTemplateGroupByParentId$Params, context?: HttpContext): Observable<CustomResultOfListOfGetSmsTemplateGroupsDto> {
    return this.smsTemplateGroupsGetSmsTemplateGroupByParentId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetSmsTemplateGroupsDto>): CustomResultOfListOfGetSmsTemplateGroupsDto => r.body)
    );
  }

  /** Path part for operation `smsTemplateGroupsDelete()` */
  static readonly SmsTemplateGroupsDeletePath = '/SmsTemplateGroups/{id}';

  /**
   * Delete SmsTemplateGroup.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smsTemplateGroupsDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  smsTemplateGroupsDelete$Response(params: SmsTemplateGroupsDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return smsTemplateGroupsDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete SmsTemplateGroup.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smsTemplateGroupsDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smsTemplateGroupsDelete(params: SmsTemplateGroupsDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.smsTemplateGroupsDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `smsTemplateGroupsUpdateGet()` */
  static readonly SmsTemplateGroupsUpdateGetPath = '/SmsTemplateGroups/Update';

  /**
   * Get SmsTemplateGroup ById for edit.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smsTemplateGroupsUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  smsTemplateGroupsUpdateGet$Response(params?: SmsTemplateGroupsUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetSmsTemplateGroupByIdDto>> {
    return smsTemplateGroupsUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get SmsTemplateGroup ById for edit.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smsTemplateGroupsUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smsTemplateGroupsUpdateGet(params?: SmsTemplateGroupsUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfGetSmsTemplateGroupByIdDto> {
    return this.smsTemplateGroupsUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetSmsTemplateGroupByIdDto>): CustomResultOfGetSmsTemplateGroupByIdDto => r.body)
    );
  }

  /** Path part for operation `smsTemplateGroupsUpdatePut()` */
  static readonly SmsTemplateGroupsUpdatePutPath = '/SmsTemplateGroups/Update';

  /**
   * Update SmsTemplateGroup.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smsTemplateGroupsUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smsTemplateGroupsUpdatePut$Response(params: SmsTemplateGroupsUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return smsTemplateGroupsUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update SmsTemplateGroup.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smsTemplateGroupsUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smsTemplateGroupsUpdatePut(params: SmsTemplateGroupsUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.smsTemplateGroupsUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `smsTemplateGroupsGetSmsTemplateGroupsAudit()` */
  static readonly SmsTemplateGroupsGetSmsTemplateGroupsAuditPath = '/SmsTemplateGroups/GetSmsTemplateGroupsAudit';

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smsTemplateGroupsGetSmsTemplateGroupsAudit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smsTemplateGroupsGetSmsTemplateGroupsAudit$Response(params: SmsTemplateGroupsGetSmsTemplateGroupsAudit$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return smsTemplateGroupsGetSmsTemplateGroupsAudit(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smsTemplateGroupsGetSmsTemplateGroupsAudit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  smsTemplateGroupsGetSmsTemplateGroupsAudit(params: SmsTemplateGroupsGetSmsTemplateGroupsAudit$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.smsTemplateGroupsGetSmsTemplateGroupsAudit$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `smsTemplateGroupsGetSmsTemplateGroupList()` */
  static readonly SmsTemplateGroupsGetSmsTemplateGroupListPath = '/SmsTemplateGroups/GetSmsTemplateGroupList';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `smsTemplateGroupsGetSmsTemplateGroupList()` instead.
   *
   * This method doesn't expect any request body.
   */
  smsTemplateGroupsGetSmsTemplateGroupList$Response(params?: SmsTemplateGroupsGetSmsTemplateGroupList$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetSmsTemplateGroupListDto>> {
    return smsTemplateGroupsGetSmsTemplateGroupList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `smsTemplateGroupsGetSmsTemplateGroupList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  smsTemplateGroupsGetSmsTemplateGroupList(params?: SmsTemplateGroupsGetSmsTemplateGroupList$Params, context?: HttpContext): Observable<CustomResultOfListOfGetSmsTemplateGroupListDto> {
    return this.smsTemplateGroupsGetSmsTemplateGroupList$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetSmsTemplateGroupListDto>): CustomResultOfListOfGetSmsTemplateGroupListDto => r.body)
    );
  }

}
